import { render } from "./FormulasStartQuestButton.vue?vue&type=template&id=6fb203de"
const script = {}

import "./FormulasStartQuestButton.vue?vue&type=style&index=0&id=6fb203de&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__